import Lottie from "lottie-react";
import React, { useEffect, useRef } from "react";

const stats = [
	{ num: "5", label: "Program Aktif" },
	{ num: "2000", label: "Target Qurban" },
	{ num: "500+", label: "Lembaga Mitra" },
];

export default function Hero({ lottieData }) {
	const heroRef = useRef(null);

	useEffect(() => {
		const el = heroRef.current;
		if (!el) return;
		el.querySelectorAll("[data-anim]").forEach((node, i) => {
			node.style.animation = `fadeUp 0.65s ${i * 0.1}s ease both`;
		});
	}, []);

	return (
		<section id="hero" className="hero-grid" ref={heroRef}>
			{/* BG decorations */}
			<div style={s.glowTR} />
			<div style={s.glowBL} />
			<div style={s.crescentBg}>☽</div>
			<div
				style={{
					...s.dot,
					top: "22%",
					left: "48%",
					animation: "float 3.2s ease-in-out infinite",
				}}>
				✦
			</div>
			<div
				style={{
					...s.dot,
					bottom: "18%",
					left: "52%",
					fontSize: "0.7rem",
					opacity: 0.4,
					animation: "float 4.5s 1.2s ease-in-out infinite",
				}}>
				✦
			</div>

			{/* ── LEFT ── */}
			<div className="hero-left" style={s.left}>
				<div data-anim style={s.tag}>
					<span>🕌</span> Program Pemberdayaan Lembaga Keislaman
				</div>

				<h1 data-anim style={s.h1}>
					Wujudkan Lembaga yang{" "}
					<em style={{ fontStyle: "normal", color: "var(--coklat2)" }}>
						Aktif, Mandiri &amp; Produktif
					</em>
				</h1>

				<span data-anim style={s.brand}>
					MASQUDE
				</span>

				<p data-anim style={s.desc}>
					Program pemberdayaan terintegrasi oleh NusaQu untuk Masjid, Yayasan,
					Pesantren, LAZ/ZISWAF, dan Komunitas Dakwah seluruh Indonesia.
				</p>

				<div data-anim className="hero-pills-row" style={s.pills}>
					{[
						"Tanpa Biaya Daftar",
						"Pendampingan Penuh",
						"Ekosistem Halal",
						"Pasar Terjamin",
					].map((p) => (
						<span key={p} style={s.pill}>
							{p}
						</span>
					))}
				</div>

				<div data-anim className="hero-btns-row" style={s.btns}>
					<a
						href="https://wa.me/62895361117333"
						style={s.btnMain}
						onMouseEnter={(e) => {
							e.currentTarget.style.background = "var(--coklat2)";
							e.currentTarget.style.transform = "translateY(-2px)";
							e.currentTarget.style.boxShadow = "0 10px 28px rgba(123,63,0,.3)";
						}}
						onMouseLeave={(e) => {
							e.currentTarget.style.background = "var(--coklat)";
							e.currentTarget.style.transform = "translateY(0)";
							e.currentTarget.style.boxShadow = "none";
						}}>
						💬 Hubungi WhatsApp
					</a>
					<a
						href="#program"
						style={s.btnOut}
						onClick={(e) => {
							e.preventDefault();
							document
								.querySelector("#program")
								?.scrollIntoView({ behavior: "smooth" });
						}}
						onMouseEnter={(e) => {
							e.currentTarget.style.background = "var(--coklat)";
							e.currentTarget.style.color = "var(--kuning2)";
							e.currentTarget.style.transform = "translateY(-2px)";
						}}
						onMouseLeave={(e) => {
							e.currentTarget.style.background = "transparent";
							e.currentTarget.style.color = "var(--coklat)";
							e.currentTarget.style.transform = "translateY(0)";
						}}>
						📋 Lihat Program →
					</a>
				</div>

				{/* Stats strip */}
				<div data-anim className="hero-stats-strip" style={s.statsStrip}>
					{stats.map((st, i) => (
						<React.Fragment key={st.label}>
							<div style={s.statItem}>
								<span className="stat-num-hero" style={s.statNum}>
									{st.num}
								</span>
								<span style={s.statLabel}>{st.label}</span>
							</div>
							{i < stats.length - 1 && <div style={s.statDivider} />}
						</React.Fragment>
					))}
				</div>
			</div>

			{/* ── RIGHT (Lottie) ── */}
			<div className="hero-right-col" style={s.right}>
				<div className="hero-lottie-frame" style={s.lottieFrame}>
					<div className="hero-ring" style={s.ring} />
					<div className="hero-ring2" style={s.ring2} />

					{lottieData ? (
						<Lottie animationData={lottieData} loop style={s.lottie} />
					) : (
						<div style={s.fallback}>
							<span style={{ fontSize: "6rem" }}>🕌</span>
						</div>
					)}

					<div className="hero-badge-tl" style={s.badgeTL}>
						<span style={s.greenDot} /> NusaQu Indonesia
					</div>

					<div className="hero-badge-br" style={s.badgeBR}>
						<span style={{ fontSize: "1.1rem" }}>🌙</span>
						<div>
							<div
								style={{
									fontWeight: 700,
									fontSize: "0.82rem",
									color: "var(--coklat)",
								}}>
								5 Program
							</div>
							<div style={{ fontSize: "0.68rem", color: "var(--abu)" }}>
								Terintegrasi
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}

const s = {
	glowTR: {
		position: "absolute",
		top: "-8%",
		right: "-8%",
		width: "600px",
		height: "600px",
		background:
			"radial-gradient(circle, rgba(240,165,0,.18) 0%, transparent 65%)",
		borderRadius: "50%",
		pointerEvents: "none",
	},
	glowBL: {
		position: "absolute",
		bottom: "-15%",
		left: "-10%",
		width: "400px",
		height: "400px",
		background:
			"radial-gradient(circle, rgba(123,63,0,.07) 0%, transparent 65%)",
		borderRadius: "50%",
		pointerEvents: "none",
	},
	crescentBg: {
		position: "absolute",
		top: "2%",
		right: "1%",
		fontSize: "18rem",
		color: "var(--coklat)",
		opacity: 0.03,
		lineHeight: 1,
		pointerEvents: "none",
		userSelect: "none",
	},
	dot: {
		position: "absolute",
		fontSize: "1rem",
		color: "var(--kuning)",
		opacity: 0.7,
	},
	left: { position: "relative", zIndex: 2 },
	tag: {
		display: "inline-flex",
		alignItems: "center",
		gap: "0.5rem",
		background: "rgba(123,63,0,.08)",
		border: "1px solid rgba(123,63,0,.2)",
		color: "var(--coklat)",
		padding: "0.4rem 1rem",
		borderRadius: "2rem",
		fontSize: "0.74rem",
		fontWeight: 700,
		letterSpacing: "1.5px",
		textTransform: "uppercase",
		marginBottom: "1.4rem",
		opacity: 0,
	},
	h1: {
		fontFamily: "Lora, serif",
		fontSize: "clamp(1.3rem, 2.5vw, 2rem)",
		fontWeight: 700,
		color: "var(--coklat)",
		lineHeight: 1.35,
		marginBottom: "0.3rem",
		opacity: 0,
	},
	brand: {
		fontFamily: "Lora, serif",
		fontStyle: "italic",
		fontSize: "clamp(3.5rem, 7vw, 6.5rem)",
		fontWeight: 700,
		color: "var(--coklat)",
		letterSpacing: "-3px",
		lineHeight: 1,
		display: "block",
		marginBottom: "1.2rem",
		opacity: 0,
	},
	desc: {
		color: "var(--abu)",
		fontSize: "0.97rem",
		lineHeight: 1.8,
		maxWidth: "100%",
		marginBottom: "1.5rem",
		opacity: 0,
	},
	pills: {
		display: "flex",
		flexWrap: "wrap",
		gap: "0.45rem",
		marginBottom: "1.8rem",
		opacity: 0,
	},
	pill: {
		background: "var(--krem2)",
		border: "1px solid rgba(123,63,0,.18)",
		color: "var(--coklat2)",
		padding: "0.3rem 0.8rem",
		borderRadius: "2rem",
		fontSize: "0.78rem",
		fontWeight: 600,
	},
	btns: { display: "flex", gap: "1rem", flexWrap: "wrap", opacity: 0 },
	btnMain: {
		background: "var(--coklat)",
		color: "var(--kuning2)",
		padding: "0.85rem 2rem",
		borderRadius: "10px",
		fontSize: "0.95rem",
		fontWeight: 700,
		textDecoration: "none",
		display: "inline-flex",
		alignItems: "center",
		gap: "0.5rem",
		transition: "all 0.25s",
	},
	btnOut: {
		background: "transparent",
		color: "var(--coklat)",
		padding: "0.85rem 2rem",
		borderRadius: "10px",
		fontSize: "0.95rem",
		fontWeight: 700,
		border: "2px solid var(--coklat)",
		textDecoration: "none",
		display: "inline-flex",
		alignItems: "center",
		gap: "0.5rem",
		transition: "all 0.25s",
	},
	statsStrip: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-around",
		marginTop: "2.2rem",
		opacity: 0,
		background: "rgba(255,248,232,0.85)",
		border: "1.5px solid rgba(123,63,0,.14)",
		borderRadius: "14px",
		padding: "1rem 1.8rem",
		backdropFilter: "blur(8px)",
		width: "100%",
	},
	statItem: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		flex: 1,
		padding: "0 0.5rem",
	},
	statNum: {
		fontFamily: "Lora, serif",
		fontSize: "1.7rem",
		fontWeight: 700,
		color: "var(--coklat)",
	},
	statLabel: {
		fontSize: "0.7rem",
		color: "var(--abu)",
		fontWeight: 600,
		marginTop: "0.1rem",
		whiteSpace: "nowrap",
	},
	statDivider: {
		width: "1.5px",
		height: "36px",
		background: "rgba(123,63,0,.15)",
		flexShrink: 0,
	},
	right: {
		position: "relative",
		zIndex: 2,
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		animation: "fadeLeft 0.8s 0.3s ease both",
	},
	lottieFrame: {
		position: "relative",
		width: "100%",
		maxWidth: "460px",
	},
	ring: {
		position: "absolute",
		inset: "-18px",
		borderRadius: "50%",
		border: "2px dashed rgba(123,63,0,.1)",
		animation: "spin-slow 28s linear infinite",
		pointerEvents: "none",
	},
	ring2: {
		position: "absolute",
		inset: "-36px",
		borderRadius: "50%",
		border: "1.5px dashed rgba(240,165,0,.12)",
		animation: "spin-slow 42s linear infinite reverse",
		pointerEvents: "none",
	},
	lottie: {
		width: "100%",
		filter: "drop-shadow(0 20px 60px rgba(123,63,0,.18))",
	},
	fallback: {
		width: "100%",
		aspectRatio: "1",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		background: "rgba(254,243,208,0.5)",
		borderRadius: "50%",
	},
	badgeTL: {
		position: "absolute",
		top: "8%",
		left: "-8%",
		background: "white",
		border: "1.5px solid rgba(123,63,0,.12)",
		borderRadius: "40px",
		padding: "0.5rem 1rem",
		display: "flex",
		alignItems: "center",
		gap: "0.5rem",
		fontSize: "0.78rem",
		fontWeight: 700,
		color: "var(--coklat)",
		boxShadow: "0 8px 24px rgba(123,63,0,.1)",
		whiteSpace: "nowrap",
		animation: "float 3.5s ease-in-out infinite",
	},
	greenDot: {
		width: "8px",
		height: "8px",
		borderRadius: "50%",
		background: "#22c55e",
		boxShadow: "0 0 0 3px rgba(34,197,94,.2)",
		flexShrink: 0,
	},
	badgeBR: {
		position: "absolute",
		bottom: "10%",
		right: "-6%",
		background: "white",
		border: "1.5px solid rgba(123,63,0,.12)",
		borderRadius: "14px",
		padding: "0.65rem 1rem",
		display: "flex",
		alignItems: "center",
		gap: "0.6rem",
		boxShadow: "0 8px 24px rgba(123,63,0,.1)",
		animation: "float 4s 0.8s ease-in-out infinite",
	},
};
